'use client'

import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import { FC, ReactNode } from 'react'
import { ContentContainer } from 'ui'
import { ContentContainerProps } from 'ui/storefront/layout/ContentContainer'

export type PageHeaderProps = {
  title: string
  description?: string
  children?: ReactNode
  containerProps?: ContentContainerProps
}

export const PageHeader: FC<PageHeaderProps> = ({
  title,
  description,
  children,
  containerProps
}) => {
  return (
    <Box w="100%" bg="background.default" borderBottom="1px solid" borderColor="border.default">
      <ContentContainer
        pt={{ base: 'calc(80px + 4rem)', md: 'calc(80px + 6rem)' }}
        pb={{ base: 6, md: 8 }}
        {...containerProps}
      >
        <VStack align="start" spacing={2} w="100%">
          <Heading
            as="h1"
            fontFamily="display"
            fontSize={{ base: '2rem', md: '2.6rem' }}
            fontWeight={500}
            lineHeight={1.2}
            letterSpacing="-0.02em"
          >
            {title}
          </Heading>
          {description && (
            <Text fontSize="1.1rem" color="text.secondary" maxW="maxWidthNarrow">
              {description}
            </Text>
          )}
          {children}
        </VStack>
      </ContentContainer>
    </Box>
  )
}
